import { Article, Course } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import type { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Article];

const config: ContentConfigProps = {
  routes: {
    create: routes.ArticleCreator,
    edit: routes.ArticleBuilder,
    view: routes.ArticleViewer,
    details: routes.ArticleViewer,
    manageDetails: routes.ArticleDetails,
  },
  label: { title, createDescription },
  icons: {
    Type: Course,
    Create: Article,
    Icon: Article,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
